// extracted by mini-css-extract-plugin
export default {"component":"kyDZg","hasIcon":"Q7eRT","container":"uxOzU","arrow":"KlHoC","icon":"Us0we","onTop":"KWo5P","text":"sTfQ8","emoji":"WcVDs"};